var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    className: "email-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125,0 L1.875,0 C0.839466094,0 0,0.839466094 0,1.875 L0,13.125 C0,14.1605339 0.839466094,15 1.875,15 L18.125,15 C19.1605339,15 20,14.1605339 20,13.125 L20,1.875 C20,0.839466094 19.1605339,0 18.125,0 Z M18.125,1.875 L18.125,3.46875 C17.25,4.1825 15.8525,5.29125 12.8675,7.62875 C12.21,8.14625 10.90625,9.38875 10,9.375 C9.09375,9.39 7.79,8.14625 7.1325,7.625 C4.1475,5.29125 2.75,4.1825 1.875,3.46875 L1.875,1.875 L18.125,1.875 Z M1.875,13.125 L1.875,5.875 C2.77,6.5875 4.04,7.58875 5.97375,9.10375 C6.8275,9.775 8.3225,11.25875 10,11.25 C11.6775,11.24125 13.145,9.7975 14.025,9.10375 C15.3958198,8.03278429 16.7624966,6.95652626 18.125,5.875 L18.125,13.125 L1.875,13.125 Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.6e845295.svg";
export { ForwardRef as ReactComponent };